export const DELIVERY_CONFIG = {
  MINIMUM_PREP_HOURS: 16,
  
  MORNING_SLOT: { start: 8, end: 12, code: 'morning', label: 'Por la mañana', time: '8:00 am - 12:00 pm' },
  AFTERNOON_SLOT: { start: 14, end: 18, code: 'afternoon', label: 'Por la tarde', time: '2:00 pm - 6:00 pm' },
  
  CUTOFF_TIMES: {
    LATE_NIGHT_CUTOFF: 22, // 10 pm
    NEXT_DAY_MORNING_CUTOFF: 18, // 6 pm
  },
  
  NO_DELIVERY_DAYS: [0], // Domingos
};

export const DELIVERY_ZONES = {
  ZONE_1: { price: 0, label: "Entrega gratis", km: 2 },
  ZONE_2: { price: 3500, label: "Entrega $3.500", km: 5.5 },
  ZONE_3: { price: 7000, label: "Entrega $7.000", km: Infinity }
};

export const getZoneConfig = (zone) => DELIVERY_ZONES[zone] || DELIVERY_ZONES[3];
export const calculateDeliveryFee = (zone) => DELIVERY_ZONES[zone]?.price || 7000;